// ============================================================
// ÂM LỊCH VIỆT NAM
// ============================================================
//
// Chuyển đổi giữa ngày dương và ngày âm, dùng cho giỗ, Tết, rằm.
//
// ⚠️ VÌ SAO PHẢI DÙNG MÚI GIỜ +7, KHÔNG PHẢI +8
// Âm lịch được tính từ thời điểm trăng non (mặt trăng nằm giữa trái đất và
// mặt trời). Thời điểm đó là một khoảnh khắc chung của cả thế giới, nhưng
// mỗi nước quy nó về giờ địa phương của mình để biết rơi vào NGÀY nào.
// Việt Nam dùng giờ +7, Trung Quốc dùng +8. Nếu trăng non rơi vào khoảng
// 23–24 giờ giờ Việt Nam thì bên Trung Quốc đã sang ngày hôm sau.
// Đó là lý do đôi khi Tết ta và Tết Tàu lệch nhau đúng một ngày.
//
// Đặt MUI_GIO = 8 là ra lịch Trung Quốc, sai với giỗ nhà mình.
//
// Thuật toán: Hồ Ngọc Đức, dựa trên "Astronomical Algorithms" của Jean Meeus.
// Không cần cài thư viện nào.
// ============================================================

const MUI_GIO = 7; // Việt Nam
const INT = (d) => Math.floor(d);

// ------------------------------------------------------------
// Đổi ngày dương sang "số ngày Julius" — một cách đánh số ngày liên tục
// từ năm 4713 trước Công nguyên. Có nó thì cộng trừ ngày rất dễ.
// ------------------------------------------------------------
function soNgayJulius(ngay, thang, nam) {
  const a = INT((14 - thang) / 12);
  const y = nam + 4800 - a;
  const m = thang + 12 * a - 3;
  let jd =
    ngay +
    INT((153 * m + 2) / 5) +
    365 * y +
    INT(y / 4) -
    INT(y / 100) +
    INT(y / 400) -
    32045;
  if (jd < 2299161) {
    // Trước 15/10/1582 thì thế giới còn dùng lịch Julius, công thức khác
    jd = ngay + INT((153 * m + 2) / 5) + 365 * y + INT(y / 4) - 32083;
  }
  return jd;
}

function tuSoNgayJulius(jd) {
  let a, b, c;
  if (jd > 2299160) {
    a = jd + 32044;
    b = INT((4 * a + 3) / 146097);
    c = a - INT((b * 146097) / 4);
  } else {
    b = 0;
    c = jd + 32082;
  }
  const d = INT((4 * c + 3) / 1461);
  const e = c - INT((1461 * d) / 4);
  const m = INT((5 * e + 2) / 153);
  const ngay = e - INT((153 * m + 2) / 5) + 1;
  const thang = m + 3 - 12 * INT(m / 10);
  const nam = b * 100 + d - 4800 + INT(m / 10);
  return [ngay, thang, nam];
}

// ------------------------------------------------------------
// Thời điểm trăng non lần thứ k (tính từ 1/1900).
// Đây là phần thiên văn thật: hiệu chỉnh theo vị trí mặt trời và mặt trăng.
// ------------------------------------------------------------
function trangNon(k) {
  const T = k / 1236.85;
  const T2 = T * T;
  const T3 = T2 * T;
  const dr = Math.PI / 180;
  let Jd1 = 2415020.75933 + 29.53058868 * k + 0.0001178 * T2 - 0.000000155 * T3;
  Jd1 = Jd1 + 0.00033 * Math.sin((166.56 + 132.87 * T - 0.009173 * T2) * dr);
  const M = 359.2242 + 29.10535608 * k - 0.0000333 * T2 - 0.00000347 * T3;
  const Mpr = 306.0253 + 385.81691806 * k + 0.0107306 * T2 + 0.00001236 * T3;
  const F = 21.2964 + 390.67050646 * k - 0.0016528 * T2 - 0.00000239 * T3;
  let C1 =
    (0.1734 - 0.000393 * T) * Math.sin(M * dr) + 0.0021 * Math.sin(2 * dr * M);
  C1 = C1 - 0.4068 * Math.sin(Mpr * dr) + 0.0161 * Math.sin(dr * 2 * Mpr);
  C1 = C1 - 0.0004 * Math.sin(dr * 3 * Mpr);
  C1 = C1 + 0.0104 * Math.sin(dr * 2 * F) - 0.0051 * Math.sin(dr * (M + Mpr));
  C1 = C1 - 0.0074 * Math.sin(dr * (M - Mpr)) + 0.0004 * Math.sin(dr * (2 * F + M));
  C1 = C1 - 0.0004 * Math.sin(dr * (2 * F - M)) - 0.0006 * Math.sin(dr * (2 * F + Mpr));
  C1 = C1 + 0.001 * Math.sin(dr * (2 * F - Mpr)) + 0.0005 * Math.sin(dr * (2 * Mpr + M));
  let deltat;
  if (T < -11) {
    deltat =
      0.001 + 0.000839 * T + 0.0002261 * T2 - 0.00000845 * T3 - 0.000000081 * T * T3;
  } else {
    deltat = -0.000278 + 0.000265 * T + 0.000262 * T2;
  }
  return Jd1 + C1 - deltat;
}

// Vị trí mặt trời trên hoàng đạo — dùng để biết tháng nào có tiết Đông chí
function viTriMatTroi(jdn) {
  const T = (jdn - 2451545.0) / 36525;
  const T2 = T * T;
  const dr = Math.PI / 180;
  const M = 357.5291 + 35999.0503 * T - 0.0001559 * T2 - 0.00000048 * T * T2;
  const L0 = 280.46645 + 36000.76983 * T + 0.0003032 * T2;
  let DL = (1.9146 - 0.004817 * T - 0.000014 * T2) * Math.sin(dr * M);
  DL = DL + (0.019993 - 0.000101 * T) * Math.sin(dr * 2 * M) + 0.00029 * Math.sin(dr * 3 * M);
  let L = (L0 + DL) * dr;
  L = L - Math.PI * 2 * INT(L / (Math.PI * 2));
  return L;
}

const viTriMatTroiTheoNgay = (soNgay) =>
  INT((viTriMatTroi(soNgay - 0.5 - MUI_GIO / 24) / Math.PI) * 6);

const ngayTrangNon = (k) => INT(trangNon(k) + 0.5 + MUI_GIO / 24);

// Tháng 11 âm lịch là tháng chứa ngày Đông chí — mốc để tính các tháng khác
function thangMuoiMotAm(nam) {
  const off = soNgayJulius(31, 12, nam) - 2415021;
  const k = INT(off / 29.530588853);
  let nm = ngayTrangNon(k);
  if (viTriMatTroiTheoNgay(nm) >= 9) {
    nm = ngayTrangNon(k - 1);
  }
  return nm;
}

// Năm nhuận âm lịch có 13 tháng — hàm này tìm xem tháng nào bị lặp
function viTriThangNhuan(a11) {
  const k = INT((a11 - 2415021.076998695) / 29.530588853 + 0.5);
  let last = 0;
  let i = 1;
  let arc = viTriMatTroiTheoNgay(ngayTrangNon(k + i));
  do {
    last = arc;
    i++;
    arc = viTriMatTroiTheoNgay(ngayTrangNon(k + i));
  } while (arc !== last && i < 14);
  return i - 1;
}

// ============================================================
// HÀM CHÍNH 1 — Dương sang Âm
// Trả về { ngay, thang, nam, nhuan }
// ============================================================
export function duongSangAm(ngay, thang, nam) {
  const soNgay = soNgayJulius(ngay, thang, nam);
  const k = INT((soNgay - 2415021.076998695) / 29.530588853);
  let dauThang = ngayTrangNon(k + 1);
  if (dauThang > soNgay) dauThang = ngayTrangNon(k);

  let a11 = thangMuoiMotAm(nam);
  let b11 = a11;
  let namAm;
  if (a11 >= dauThang) {
    namAm = nam;
    a11 = thangMuoiMotAm(nam - 1);
  } else {
    namAm = nam + 1;
    b11 = thangMuoiMotAm(nam + 1);
  }

  const ngayAm = soNgay - dauThang + 1;
  const chenhLech = INT((dauThang - a11) / 29);
  let nhuan = 0;
  let thangAm = chenhLech + 11;

  if (b11 - a11 > 365) {
    const viTriNhuan = viTriThangNhuan(a11);
    if (chenhLech >= viTriNhuan) {
      thangAm = chenhLech + 10;
      if (chenhLech === viTriNhuan) nhuan = 1;
    }
  }
  if (thangAm > 12) thangAm = thangAm - 12;
  if (thangAm >= 11 && chenhLech < 4) namAm -= 1;

  return { ngay: ngayAm, thang: thangAm, nam: namAm, nhuan };
}

// ============================================================
// HÀM CHÍNH 2 — Âm sang Dương
// Cần cho việc "giỗ lặp lại hằng năm": biết ngày âm của giỗ, tính ra
// ngày dương của năm nay để đưa vào lịch và nhắc trước.
// Trả về { ngay, thang, nam } — hoặc null nếu ngày âm đó không tồn tại
// (ví dụ hỏi tháng nhuận trong một năm không nhuận).
// ============================================================
export function amSangDuong(ngayAm, thangAm, namAm, nhuan = 0) {
  let a11, b11;
  if (thangAm < 11) {
    a11 = thangMuoiMotAm(namAm - 1);
    b11 = thangMuoiMotAm(namAm);
  } else {
    a11 = thangMuoiMotAm(namAm);
    b11 = thangMuoiMotAm(namAm + 1);
  }

  let off = thangAm - 11;
  if (off < 0) off += 12;

  if (b11 - a11 > 365) {
    const viTriNhuan = viTriThangNhuan(a11);
    let thangNhuan = viTriNhuan - 2;
    if (thangNhuan < 0) thangNhuan += 12;
    if (nhuan !== 0 && thangAm !== thangNhuan) return null;
    if (nhuan !== 0 || off >= viTriNhuan) off += 1;
  }

  const k = INT(0.5 + (a11 - 2415021.076998695) / 29.530588853);
  const dauThang = ngayTrangNon(k + off);
  const [d, m, y] = tuSoNgayJulius(dauThang + ngayAm - 1);
  return { ngay: d, thang: m, nam: y };
}

// ============================================================
// CAN CHI — "Bính Ngọ", "Ất Tỵ"...  Dùng khi nói về năm giỗ, năm Tết.
// ============================================================
const CAN = ["Giáp", "Ất", "Bính", "Đinh", "Mậu", "Kỷ", "Canh", "Tân", "Nhâm", "Quý"];
const CHI = ["Tý", "Sửu", "Dần", "Mão", "Thìn", "Tỵ", "Ngọ", "Mùi", "Thân", "Dậu", "Tuất", "Hợi"];

export const canChiNam = (namAm) =>
  `${CAN[(namAm + 6) % 10]} ${CHI[(namAm + 8) % 12]}`;

// ============================================================
// HIỂN THỊ — chữ ngắn để đặt cạnh ngày dương
// Chủ nhà quan tâm âm lịch, các con thì không → hiện nhỏ, nhạt, không
// chiếm chỗ. KHÔNG làm một cái lịch âm riêng.
// ============================================================

/** "mùng 3 tháng 7" · "rằm tháng 8" · "23 tháng 12 nhuận" */
export function chuNgayAm(giaTriNgayDuong) {
  if (!giaTriNgayDuong) return "";
  const d = new Date(giaTriNgayDuong);
  if (isNaN(d.getTime())) return "";

  const am = duongSangAm(d.getDate(), d.getMonth() + 1, d.getFullYear());

  let phanNgay;
  if (am.ngay === 15) phanNgay = "rằm";
  else if (am.ngay <= 10) phanNgay = `mùng ${am.ngay}`;
  else phanNgay = `${am.ngay}`;

  return `${phanNgay} tháng ${am.thang}${am.nhuan ? " nhuận" : ""}`;
}

/** "(âm: mùng 3 tháng 7)" — chuỗi hoàn chỉnh để chèn cạnh ngày dương */
export const chuNgayAmDayDu = (giaTriNgayDuong) => {
  const s = chuNgayAm(giaTriNgayDuong);
  return s ? `(âm: ${s})` : "";
};
